/**
 * 公开接口封装（免鉴权），走 Vite proxy `/api` → http://localhost:8080
 */

const API_BASE = '/api/v1';

interface ApiEnvelope<T> {
  code: number;
  message?: string;
  data: T;
}

async function request<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`);
  let body: ApiEnvelope<T> | undefined;

  try {
    body = (await res.json()) as ApiEnvelope<T>;
  } catch {
    // 非 JSON 响应，交给下方统一处理
  }

  if (!res.ok) {
    throw new Error(body?.message || `请求失败（HTTP ${res.status}），请稍后重试`);
  }
  if (!body || body.code !== 0) {
    throw new Error(body?.message || '服务返回异常，请稍后重试');
  }
  return body.data;
}

export interface Cattle {
  id: number;
  ear_tag_no: string;
  rfid_tag?: string;
  breed?: string;
  gender?: number; // 0-母 1-公
  birth_date?: string | null;
  weight?: number;
  coat_color?: string;
  farm_name?: string;
  farm_address?: string;
  health_status?: string;
  quarantine_cert?: string;
  source_type?: number; // 1-自繁 2-外购 3-进口
  source_desc?: string;
  status?: number; // 0-在栏 1-已售 2-死亡 3-屠宰
  face_image_url?: string;
}

export interface TraceEvent {
  id: number;
  cattle_id: number;
  event_type: number;
  event_desc?: string;
  location?: string;
  operator?: string;
  remark?: string | null;
  event_time: string;
}

export interface TraceData {
  cattle: Cattle;
  traces: TraceEvent[];
}

export interface MarketPriceItem {
  breed: string;
  price: number;
  unit: string;
  date: string;
}

export interface CertData {
  found: boolean;
  tx_hash: string;
  block_number: number;
  block_time: string | null;
  tx_status: number;
}

export function getCattleTrace(earTagNo: string): Promise<TraceData> {
  return request<TraceData>(`/public/cattle/trace/${encodeURIComponent(earTagNo)}`);
}

export function getMarketPrice(): Promise<MarketPriceItem[]> {
  return request<MarketPriceItem[]>('/public/market/price');
}

export function getCert(txHash: string): Promise<CertData> {
  return request<CertData>(`/public/cert/${encodeURIComponent(txHash)}`);
}
